import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { toast } from 'react-toastify';
import ApiService from '../services/api-service'; // Adjust the import path as necessary

const FavoriteButton = ({ 
  itemId, 
  itemType = 'music', // 'music', 'videos', or 'studios'
  userSaves = [],
  onSaveToggle = () => {},
  size = 24,
  color = '#ff0000',
  className = '',
  ...rest 
}) => {
  const [isSaved, setIsSaved] = useState(false);
  const [savingInProgress, setSavingInProgress] = useState(false);

  useEffect(() => {
    // Check if this item is in user's saves
    const isCurrentlySaved = userSaves.includes(itemId);
    console.log(`FavoriteButton - Item ${itemId} saved status:`, isCurrentlySaved, 'userSaves:', userSaves);
    setIsSaved(isCurrentlySaved);
  }, [userSaves, itemId]);

  const handleSaveToggle = async (e) => {
    e.stopPropagation();
    
    if (savingInProgress) return;
    
    setSavingInProgress(true);
    
    try {
      if (isSaved) {
        // Remove from saves
        await ApiService.REMOVE_SAVE(itemType, { id: itemId });
        setIsSaved(false);
        toast.success(`Removed from your ${itemType} saves`);
        onSaveToggle(itemId, false);
      } else {
        // Add to saves
        await ApiService.ADD_SAVE(itemType, { id: itemId });
        setIsSaved(true);
        toast.success(`Added to your ${itemType} saves`);
        onSaveToggle(itemId, true);
      }
    } catch (error) {
      console.error('Error toggling save:', error);
      
      // Handle "already saved" error gracefully
      if (error.response?.status === 400 && error.response?.data?.message?.includes?.('already saved')) {
        // If trying to add but already saved, update the state to reflect reality
        setIsSaved(true);
        onSaveToggle(itemId, true);
        toast.success(`Already in your ${itemType} saves`);
      } else {
        toast.error('Failed to update saves');
      }
    } finally {
      setSavingInProgress(false);
    }
  };

 return (
    <IconButton
      onClick={handleSaveToggle}
      className={`save-btn _cp ${className}`}
      title={isSaved ? "Remove from saves" : "Add to saves"}
      disabled={savingInProgress}
      {...rest}
    >
      {isSaved ? (
        <FavoriteIcon sx={{ fontSize: size, color: color }} />
      ) : (
        <FavoriteBorderIcon sx={{ fontSize: size, color: '#fff' }} />
      )}
    </IconButton>
  );
};

export default FavoriteButton;